import { InsurancePaymentType } from '@/common/queries/selections/insurancePaymentBy/insurancePaymentBy.type';
import { fetchApi } from '@/config/axiosSetting';

export const getInsurancePaymentByFunction = (): Promise<
  InsurancePaymentType[]
> => {
  return fetchApi.get('/selection_item/insurance_payment_by/wop_list/');
};
